export const hasCrmAccessScopes = scopes => scopes.includes('crm-access') || scopes.includes('contacts-read');